import { Heading, VStack, HStack, Text } from '@primerai/thread';
import CheckmarkIcon from './CheckmarkIcon';
import { runTests } from '~/components/password/rules';
import {
  ConfigType,
  TestResultType,
  configIsValid,
} from '~/components/password/types';

type ItemProps = {
  label: string;
  passed: boolean | undefined;
};

export const Requirement = ({ label, passed }: ItemProps) => (
  <HStack alignItems="center">
    <CheckmarkIcon checked={!!passed} />
    <Text>{label}</Text>
  </HStack>
);

const getResults = (
  currentRuleSet: ConfigType | undefined,
  password: string,
) => {
  if (configIsValid(currentRuleSet)) {
    return runTests(currentRuleSet, password);
  }
  return [];
};

type FeedbackProps = {
  currentRuleSet: ConfigType | undefined;
  password: string;
  passwordsMatch?: boolean;
};

// todo: call an event handler on pass and failure
export const RequirementsFeedback = ({
  currentRuleSet,
  password,
  passwordsMatch,
}: FeedbackProps) => {
  const results = getResults(currentRuleSet, password);
  return (
    <VStack>
      <Heading>Password Requirements</Heading>
      <Requirement label="Passwords match" passed={passwordsMatch} />
      {results.map((result: TestResultType) => (
        <Requirement {...result} key={result.label} />
      ))}
    </VStack>
  );
};
